Ext.ns('mx.comp');

mx.comp.DayField = Ext.extend(mx.comp.FieldGroup, {
    labels: {
        timeFieldEmptyTextLabel: 'hh:mm',
        regexText: 'Time must be in hh:mm format',
    },

    checkboxWidth: 17,

    labelWidth: 88,

    dashWidth: 21,

    timeFieldWidth: 65,

    showCheckbox: true,

    showTimeFields: true,

    dayOfWeek: null,

    label: '',

    labelSeparator: ':',

    checkboxDefaultChecked: false,

    timeFieldEmptyText: 'hh:mm',

    isFieldContainer: false,

    hideLabel: true,

    cls: 'mx-comp-dayfield',

    required: false,

    onManualChange: function() {
        this.fireEvent('manualChange', this);
    },

    initComponent: function() {
        this.addEvents('manualChange');
        mx.comp.DayField.superclass.initComponent.call(this);

        var thiz = this;

        var columns = [];
        var items = [];
        this.name = this.name || this.id;

        if (this.showCheckbox) {
            columns.push(this.checkboxWidth);
            this.checkbox = new Ext.form.Checkbox({
                name: this.name + '-enabled',
                checked: this.checkboxDefaultChecked,
                handler: function(cb, checked) {
                    thiz.onManualChange();
                    if (this.showTimeFields) {
                        this.spinnerFrom.setDisabled(cb.disabled || !checked);
                        this.spinnerTo.setDisabled(cb.disabled || !checked);
                    }
                },
                // check event will fire on every change (even by automatc change), focus, click, change - are never fired...
                //                listeners: {
                //                    'focus': {
                //                        fn: function() {
                //                            this.onManualChange();
                //                        },
                //                        scope: this
                //                    }
                //                },
                scope: this,
            });
            items.push(this.checkbox);
        }

        columns.push(this.labelWidth);
        items.push({
            xtype: 'label',
            text: this.label + (this.showTimeFields ? this.labelSeparator : ''),
            forId: this.showCheckbox ? this.checkbox.getId() : null,
        });

        if (this.showTimeFields) {
            columns.push(this.timeFieldWidth, this.dashWidth, this.timeFieldWidth);
            this.spinnerFrom = new Ext.ux.form.Spinner({
                disabled: !this.checkboxDefaultChecked,
                strategy: {
                    xtype: 'time',
                },
                regex: MXBT.getRegexpFromTimeFormat(MXBT.getDateFormat('time')),
                regexText: this.labels.regexText,
                name: this.name + '-from',
                emptyText: this.labels.timeFieldEmptyTextLabel,
                listeners: {
                    spin: {
                        fn: function() {
                            this.getEl().removeClass('x-form-empty-field');
                            thiz.onManualChange();
                        },
                    },
                    change: {
                        fn: function() {
                            thiz.onManualChange();
                        },
                    },
                },
            });
            this.spinnerTo = new Ext.ux.form.Spinner({
                disabled: !this.checkboxDefaultChecked,
                strategy: {
                    xtype: 'time',
                },
                name: this.name + '-to',
                emptyText: this.labels.timeFieldEmptyTextLabel,
                regex: MXBT.getRegexpFromTimeFormat(MXBT.getDateFormat('time')),
                regexText: this.labels.regexText,
                listeners: {
                    spin: {
                        fn: function() {
                            this.getEl().removeClass('x-form-empty-field');
                            thiz.onManualChange();
                        },
                    },
                    change: {
                        fn: function() {
                            thiz.onManualChange();
                        },
                    },
                },
            });
            items.push(
                this.spinnerFrom,
                {
                    xtype: 'label',
                    html: '&#8212;',
                    cls: 'dash',
                },
                this.spinnerTo
            );
        }

        this.columns = columns;

        this.items = items;
    },
    clearValue: function() {
        if (this.showCheckbox) {
            this.checkbox.setValue(false);
        }
        if (this.showTimeFields) {
            this.spinnerFrom.setValue(null);
            this.spinnerFrom.setDisabled(true);

            this.spinnerTo.setValue(null);
            this.spinnerTo.setDisabled(true);
        }
    },
    setValue: function(/*mx.data.AvailableTime*/ val) {
        if (val.get('day_of_week') == this.dayOfWeek) {
            if (this.showCheckbox) {
                this.checkbox.setValue(val.get('available'));
                this.checkbox.originalValue = val.get('available');
            }
            if (this.showTimeFields) {
                this.spinnerFrom.setValue(val.get('start_time'));
                this.spinnerFrom.setDisabled((this.showCheckbox && this.checkbox.disabled) || !val.get('available'));
                this.spinnerFrom.initValue();

                this.spinnerTo.setValue(val.get('end_time'));
                this.spinnerTo.setDisabled((this.showCheckbox && this.checkbox.disabled) || !val.get('available'));
                this.spinnerTo.initValue();
            }
        }
    },
    getValue: function() {
        return new mx.data.AvailableTime({
            available: this.showCheckbox ? this.checkbox.checked : true,
            start_time: this.showTimeFields ? this.spinnerFrom.getValue() : null,
            end_time: this.showTimeFields ? this.spinnerTo.getValue() : null,
            day_of_week: this.dayOfWeek,
        });
    },
    validate: function() {
        if (this.showTimeFields) {
            this.spinnerFrom.clearInvalid();
            this.spinnerTo.clearInvalid();
            if (this.showCheckbox) {
                if (!this.spinnerFrom.disabled && !this.spinnerTo.disabled) {
                    if (!this.spinnerFrom.getValue() || !this.spinnerTo.getValue()) {
                        this.spinnerFrom.markInvalid();
                        this.spinnerTo.markInvalid();
                        return false;
                    } else {
                        return this.spinnerFrom.validate() && this.spinnerTo.validate();
                    }
                }
            } else {
                var from = this.spinnerFrom.getValue();
                var to = this.spinnerTo.getValue();

                var valid;

                if (this.spinnerFrom.getRawValue() != '' || this.spinnerTo.getRawValue() != '') {
                    if (!this.spinnerFrom.getValue() || !this.spinnerTo.getValue()) {
                        this.spinnerFrom.markInvalid();
                        this.spinnerTo.markInvalid();
                        return false;
                    } else {
                        valid = this.spinnerFrom.validate() && this.spinnerTo.validate();
                    }
                } else {
                    valid = this.spinnerFrom.validate() && this.spinnerTo.validate();
                }

                if (valid && from && to) {
                    var fromTime = +Date.parseDate(from, 'G:i');
                    var toTime = +Date.parseDate(to, 'G:i');
                    if (fromTime >= toTime) {
                        this.spinnerTo.markInvalid("Interval end shouldn't be less than interval");
                        return false;
                    } else {
                        return true;
                    }
                }
            }
        }
        return true;
    },
});

Ext.reg('mx_dayfield', mx.comp.DayField);

mx.comp.DayFieldExt = Ext.extend(mx.comp.DayField, {
    initComponent: function() {
        this.addEvents('manualChange');
        mx.comp.DayField.superclass.initComponent.call(this);
        this.available = true;

        var columns = [];
        var items = [];
        this.name = this.name || this.id;

        if (this.showCheckbox) {
            columns.push(this.checkboxWidth);
            this.checkbox = new Ext.form.Checkbox({
                name: this.name + '-enabled',
                checked: this.checkboxDefaultChecked,
                handler: function(cb, checked) {
                    this.onManualChange();
                    if (this.showTimeFields) {
                        this.spinnerFrom.setDisabled(cb.disabled || !checked);
                        this.spinnerTo.setDisabled(cb.disabled || !checked);
                    }
                },
                scope: this,
            });
            items.push(this.checkbox);
        }

        columns.push(this.labelWidth);
        columns.push(this.labelWidth);
        items.push((this.leftLabel = new Ext.form.Label()));
        items.push({
            xtype: 'label',
            text: this.label + (this.showTimeFields ? this.labelSeparator : ''),
            forId: this.showCheckbox ? this.checkbox.getId() : null,
        });

        if (this.showTimeFields) {
            columns.push(this.timeFieldWidth, this.dashWidth, this.timeFieldWidth, 100);
            this.spinnerFrom = new Ext.ux.form.Spinner({
                disabled: !this.checkboxDefaultChecked,
                strategy: {
                    xtype: 'time',
                },
                regex: MXBT.getRegexpFromTimeFormat(MXBT.getDateFormat('time')),
                regexText: this.labels.regexText,
                name: this.name + '-from',
                emptyText: this.labels.timeFieldEmptyTextLabel,
                listeners: {
                    spin: {
                        fn: function() {
                            this.getEl().removeClass('x-form-empty-field');
                            this.onManualChange();
                        },
                        scope: this,
                    },
                    change: {
                        fn: function() {
                            this.onManualChange();
                        },
                        scope: this,
                    },
                },
            });
            this.spinnerTo = new Ext.ux.form.Spinner({
                disabled: !this.checkboxDefaultChecked,
                strategy: {
                    xtype: 'time',
                },
                name: this.name + '-to',
                emptyText: this.labels.timeFieldEmptyTextLabel,
                regex: MXBT.getRegexpFromTimeFormat(MXBT.getDateFormat('time')),
                regexText: this.labels.regexText,
                listeners: {
                    spin: {
                        fn: function() {
                            this.getEl().removeClass('x-form-empty-field');
                            this.onManualChange();
                        },
                        scope: this,
                    },
                    change: {
                        fn: function() {
                            this.onManualChange();
                        },
                        scope: this,
                    },
                },
            });
            this.buttonConfig = Ext.apply(this.buttonConfig, {
                field: this,
                disabled: true,
            });

            this.on(
                'manualChange',
                function() {
                    var from = this.spinnerFrom.getValue();
                    var to = this.spinnerTo.getValue();
                    this.button.setDisabled(true);

                    if (from && to) {
                        var fromTime = +Date.parseDate(from, 'G:i');
                        var toTime = +Date.parseDate(to, 'G:i');
                        if (fromTime < toTime) {
                            this.button.setDisabled(false);
                        }
                    }
                },
                this
            );

            this.button = new Ext.ux.ResizableButtonComponent(this.buttonConfig);
            items.push(
                this.spinnerFrom,
                {
                    xtype: 'label',
                    html: '&#8212;',
                    cls: 'dash',
                },
                this.spinnerTo,
                this.button
            );
        }

        this.columns = columns;

        this.items = items;
    },
    setValue: function(/*mx.data.AvailableTime*/ val) {
        if (val.get('day_of_week') == this.dayOfWeek) {
            if (this.showCheckbox) {
                this.checkbox.setValue(val.get('available'));
                this.checkbox.originalValue = val.get('available');
            } else {
                this.available = val.get('available');
            }
            if (this.showTimeFields) {
                this.spinnerFrom.setValue(val.get('start_time'));
                this.spinnerFrom.setDisabled((this.showCheckbox && this.checkbox.disabled) || !val.get('available'));
                this.spinnerFrom.initValue();

                this.spinnerTo.setValue(val.get('end_time'));
                this.spinnerTo.setDisabled((this.showCheckbox && this.checkbox.disabled) || !val.get('available'));
                this.spinnerTo.initValue();

                this.button.setDisabled(!val.get('start_time') || !val.get('end_time'));
            }
            this.records = val.get('records');
            this.actualDate = val.get('actualDate');
            this.leftLabel.setText(Ext.util.Format.date(this.actualDate, MXBT.getDateFormat('fulldate')));
        }
    },
    getValue: function() {
        return new mx.data.AvailableTime({
            available: this.showCheckbox ? this.checkbox.checked : this.available,
            start_time: this.showTimeFields ? this.spinnerFrom.getValue() : null,
            end_time: this.showTimeFields ? this.spinnerTo.getValue() : null,
            day_of_week: this.dayOfWeek,
            actualDate: this.actualDate,
            records: this.records,
        });
    },
});

mx.comp.WeekField = Ext.extend(mx.comp.FieldGroup, {
    labels: {
        sunday: 'Sunday',
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        holiday: 'Holidays',
    },

    fieldConstructor: mx.comp.DayField,

    showHolidays: true,

    checkboxDefaultChecked: false,

    showCheckbox: true,

    showTimeFields: true,

    labelWidth: 88,

    timeFieldWidth: 65,

    twoColumns: false,

    buttonConfig: {},

    isFieldContainer: false,

    initComponent: function() {
        this.addEvents('manualChange');
        mx.comp.WeekField.superclass.initComponent.call(this);

        this.name = this.name || this.id;

        var listeners = {
            manualChange: {
                fn: function(e) {
                    this.fireEvent('manualChange', e);
                },
                scope: this,
            },
        };

        this.sunday = new this.fieldConstructor({
            label: this.labels.sunday,
            name: this.name + '-sunday',
            dayOfWeek: 'sunday',
            buttonConfig: this.buttonConfig,
            showCheckbox: this.showCheckbox,
            showTimeFields: this.showTimeFields,
            labelWidth: this.labelWidth,
            timeFieldWidth: this.timeFieldWidth,
            checkboxDefaultChecked: this.checkboxDefaultChecked,
            listeners: listeners,
        });
        this.monday = new this.fieldConstructor({
            label: this.labels.monday,
            name: this.name + '-monday',
            dayOfWeek: 'monday',
            buttonConfig: this.buttonConfig,
            showCheckbox: this.showCheckbox,
            showTimeFields: this.showTimeFields,
            labelWidth: this.labelWidth,
            timeFieldWidth: this.timeFieldWidth,
            checkboxDefaultChecked: this.checkboxDefaultChecked,
            listeners: listeners,
        });
        this.tuesday = new this.fieldConstructor({
            label: this.labels.tuesday,
            name: this.name + '-tuesday',
            dayOfWeek: 'tuesday',
            buttonConfig: this.buttonConfig,
            showCheckbox: this.showCheckbox,
            showTimeFields: this.showTimeFields,
            labelWidth: this.labelWidth,
            timeFieldWidth: this.timeFieldWidth,
            checkboxDefaultChecked: this.checkboxDefaultChecked,
            listeners: listeners,
        });
        this.wednesday = new this.fieldConstructor({
            label: this.labels.wednesday,
            name: this.name + '-wednesday',
            dayOfWeek: 'wednesday',
            buttonConfig: this.buttonConfig,
            showCheckbox: this.showCheckbox,
            showTimeFields: this.showTimeFields,
            labelWidth: this.labelWidth,
            timeFieldWidth: this.timeFieldWidth,
            checkboxDefaultChecked: this.checkboxDefaultChecked,
            listeners: listeners,
        });
        this.thursday = new this.fieldConstructor({
            label: this.labels.thursday,
            name: this.name + '-thursday',
            dayOfWeek: 'thursday',
            buttonConfig: this.buttonConfig,
            showCheckbox: this.showCheckbox,
            showTimeFields: this.showTimeFields,
            labelWidth: this.labelWidth,
            timeFieldWidth: this.timeFieldWidth,
            checkboxDefaultChecked: this.checkboxDefaultChecked,
            listeners: listeners,
        });
        this.friday = new this.fieldConstructor({
            label: this.labels.friday,
            name: this.name + '-friday',
            dayOfWeek: 'friday',
            buttonConfig: this.buttonConfig,
            showCheckbox: this.showCheckbox,
            showTimeFields: this.showTimeFields,
            labelWidth: this.labelWidth,
            timeFieldWidth: this.timeFieldWidth,
            checkboxDefaultChecked: this.checkboxDefaultChecked,
            listeners: listeners,
        });
        this.saturday = new this.fieldConstructor({
            label: this.labels.saturday,
            name: this.name + '-saturday',
            dayOfWeek: 'saturday',
            buttonConfig: this.buttonConfig,
            showCheckbox: this.showCheckbox,
            showTimeFields: this.showTimeFields,
            labelWidth: this.labelWidth,
            timeFieldWidth: this.timeFieldWidth,
            checkboxDefaultChecked: this.checkboxDefaultChecked,
            listeners: listeners,
        });
        this.holiday = new this.fieldConstructor({
            label: this.labels.holiday,
            name: this.name + '-holiday',
            dayOfWeek: 'holiday',
            buttonConfig: this.buttonConfig,
            showCheckbox: this.showCheckbox,
            showTimeFields: this.showTimeFields,
            labelWidth: this.labelWidth,
            timeFieldWidth: this.timeFieldWidth,
            checkboxDefaultChecked: this.checkboxDefaultChecked,
            listeners: listeners,
        });

        var weekitems;
        if (MXBT.get('dateFormats').weekstart == 1) {
            weekitems = [
                this.monday,
                this.tuesday,
                this.wednesday,
                this.thursday,
                this.friday,
                this.saturday,
                this.sunday,
            ];
        } else {
            weekitems = [
                this.sunday,
                this.monday,
                this.tuesday,
                this.wednesday,
                this.thursday,
                this.friday,
                this.saturday,
            ];
        }
        if (this.showHolidays) {
            weekitems.push(this.holiday);
        }

        if (this.twoColumns) {
            this.items = [
                {
                    xtype: 'panel',
                    columnWidth: 0.5,
                    border: false,
                    layout: 'anchor',
                    defaults: {
                        anchor: '100%',
                    },
                    items: weekitems.slice(0, 4),
                },
                {
                    xtype: 'panel',
                    columnWidth: 0.5,
                    border: false,
                    layout: 'anchor',
                    defaults: {
                        anchor: '100%',
                    },
                    items: weekitems.slice(4, 8),
                },
            ];
        } else {
            this.items = [
                {
                    xtype: 'panel',
                    columnWidth: 1.0,
                    border: false,
                    layout: 'anchor',
                    defaults: {
                        anchor: '100%',
                    },
                    items: weekitems,
                },
            ];
        }
    },

    clearValue: function() {
        this.sunday.clearValue();
        this.monday.clearValue();
        this.tuesday.clearValue();
        this.wednesday.clearValue();
        this.thursday.clearValue();
        this.friday.clearValue();
        this.saturday.clearValue();
        if (this.showHolidays) {
            this.holiday.clearValue();
        }
    },

    setValue: function(/*Array<mx.data.AvailableTime>*/ week) {
        if (Ext.isArray(week)) {
            Ext.each(
                week,
                function(availableTime) {
                    this[availableTime.get('day_of_week')].setValue(availableTime);
                },
                this
            );
        }
    },
    isDirty: function() {
        return Ext.encode(this.getValue()) != Ext.encode(this.originalValue);
    },

    getValue: function() {
        var result = [
            this.sunday.getValue(),
            this.monday.getValue(),
            this.tuesday.getValue(),
            this.wednesday.getValue(),
            this.thursday.getValue(),
            this.friday.getValue(),
            this.saturday.getValue(),
        ];
        if (this.showHolidays) {
            result.push(this.holiday.getValue());
        }

        return result;
    },

    getName: function() {
        return this.name;
    },

    validate: function() {
        var a1 = this.sunday.validate();
        var a2 = this.monday.validate();
        var a3 = this.tuesday.validate();
        var a4 = this.wednesday.validate();
        var a5 = this.thursday.validate();
        var a6 = this.friday.validate();
        var a7 = this.saturday.validate();
        var a8 = true;
        if (this.showHolidays) {
            var a8 = this.holiday.validate();
        }
        return a1 && a2 && a3 && a4 && a5 && a6 && a7 && a8;
    },
});

Ext.reg('mx_weekfield', mx.comp.WeekField);
